import React from 'react'

import { ZariContext } from '_zari/context'

import * as Sections from './sections'

import * as AsientoContableService from 'services/asientosContables.service'

const NoDomiciliadosPage = () => {
  const __zariContext = React.useContext(ZariContext)

  const [idDocumento, setIdDocumento] = React.useState(null)
  const [editarData, setEditarData] = React.useState(null)

  const asignarIdDocumento = React.useCallback(
    id => {
      setIdDocumento(id)

      AsientoContableService.obtenerInfoNoDomiciliadoxIdAsientoContable(id)
        .then(({ data }) => {
          if (data) {
            setEditarData(data)
          }
        })
        .catch(() => {
          __zariContext.snack('error', 'No se puedo obtener la informacion de no domiciliado.')
        })
    },
    [__zariContext]
  )

  const limpiarIdDocumento = React.useCallback(() => {
    setIdDocumento(null)
    setEditarData(null)
  }, [])

  return (
    <>
      <Sections.FiltrosSection asignarIdDocumento={asignarIdDocumento} limpiarIdDocumento={limpiarIdDocumento} />
      {idDocumento && editarData ? (
        <Sections.FormularioSection limpiarIdDocumento={limpiarIdDocumento} idDocumentoContable={idDocumento} editarData={editarData || {}} />
      ) : null}
    </>
  )
}

export default React.memo(NoDomiciliadosPage)
